<template>

<div class="modal" v-if="active">

	<div class="modal-box">

		<div class="modal-box-head"><app-icon icon="paperwork" /></div>

		<div class="modal-box-content">
		
			<div class="modal-box-content-text"><p v-html="text" /></div>

			<div class="modal-box-content-button">

				<app-button :loading="loading" v-on:click="onAcceptClick" text="Accept" />
				<app-button :disabled="loading" v-on:click="onDeclineClick" theme="plain" text="Decline" />

			</div>

			<p class="modal-box-content-foot">By clicking accept you agree to the Terms of Use and Privacy Policy of cardboardevents.com</p>
		
		</div>

	</div>

</div>

</template>

<script>

export default {

	data: function() {

		return {
			accept: false,
			loading: false
		}

	},

	computed: {

		text: function() {

			var text = ['Hi! We\'ve updated our']

			if(!this.$store.getters['session/accepted'].terms) text.push(' <a href="https://cardboardevents.com/terms" target="_blank">Terms of Use</a>')

			if(!this.$store.getters['session/accepted'].terms && !this.$store.getters['session/accepted'].privacy) text.push(' and')

			if(!this.$store.getters['session/accepted'].privacy) text.push(' <a href="https://cardboardevents.com/privacy" target="_blank">Privacy Policy</a>')

			text.push('. Please take a moment to read them using the links above before continuing to use the website.')

			return text.join('')

		},

		active: function() {

			return !this.$store.getters['session/accepted'].terms || !this.$store.getters['session/accepted'].privacy

		}

	},

	methods: {

		onAcceptClick: async function() {

			this.loading = true

			await this.$api.post('session/accept')

		},

		onDeclineClick: function() {

			this.$router.push({
				name: 'Logout'
			})

		}

	}

}

</script>

<style>

.modal {
	position: fixed;
	left: 0px;
	top: 0px;
	bottom: 0px;
	right: 0px;
	background-color: rgba(0, 0, 0, 0.75);
	z-index: 10002;
	display: flex;
	justify-content: center;
	align-items: center;
}

.modal-box {
	max-width: 480px;
	width: calc(100% - 20px);
}

.modal-box-head {
	height: 160px;
	color: #fff;
	border-radius: 4px 4px 0px 0px;
	background-color: #4082d3;
	line-height: 160px;
	text-align: center;
	font-size: 96px;
}

.modal-box-content {
	padding: 20px;
	background-color: #fff;
	border-radius: 0px 0px 4px 4px;
}

.modal-box-content-text {
	margin-bottom: 20px;
	font-size: 16px;
	line-height: 20px;
	text-align: center;
}

.modal-box-content-text a {
	color: #387DD8;
	font-weight: 500;
}

.modal-box-content-text a:hover {
	text-decoration: underline;
}

.modal-box-content-text p {
	margin-bottom: 20px;
}

.modal-box-content-text p:last-child {
	margin-bottom: 0px;
}

.modal-box-content-date {
	text-align: center;
	margin: 20px 0px;
	font-size: 12px;
	color: #666;
}

.modal-box-content-button {
	display: flex;
	justify-content: center;
}

.modal-box-content-button .button {
	margin: 0px 10px!important;
}

.modal-box-content-foot {
	font-size: 12px;
	text-align: center;
	line-height: 16px;
	margin-top: 20px;
	color: #333;
}

</style>
